import { createFileRoute } from '@tanstack/react-router';
import PersonalDataDiversity from '@/features/account/profile/personal-data/diversity';

export const Route = createFileRoute('/perfil/dados-pessoais/diversidade')({
  component: PersonalDataDiversity,
  staticData: { subtitle: 'Diversidade' },
});
